import React from 'react';
import { Button } from '@chakra-ui/react';
import { i18n } from '../../../../i18n/index.js';
import { Layout } from '../../Layout/component.js';
var SubmitButton = function SubmitButton(_ref) {
  var submitButtonText = _ref.submitButtonText,
    submitDisabled = _ref.submitDisabled;
  return /*#__PURE__*/React.createElement(Layout, {
    mt: 4,
    variant: 'flex'
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "primary",
    isDisabled: submitDisabled
  }, submitButtonText || i18n.t('Submit')));
};
SubmitButton.displayName = "SubmitButton";
export { SubmitButton };